import { Box, Container, Typography } from '@ace-clublabs/shared-component-library';
import { MembersDetailsActionButtons } from '../components/MembershipButtonGroups/MembersDetailsActionButtons';
import { MembersDetailsOverview } from '../components/MembersDetailsOverview';
import { MembershipBreadcrumbs } from '../components/Breadcrumbs/Breadcrumbs';
import { useLayoutEffect, useState } from 'react';
import { UtagHelper, UtagType } from '../utils/UtagHelper';
import { useGlobalState } from '../state/state';

export const MembersDetails: React.FC = () => {
  const [tags] = useGlobalState('tags');
  const [isTagging, setTagging] = useState(true);
  const [isMobileApp] = useGlobalState('isMobileApp');

  useLayoutEffect(() => {
    UtagHelper.sendTag(UtagType.view, tags, 'member details');
    setTagging(false);
  }, []);

  if (isTagging) {
    return <></>;
  }

  return (
    <>
      <Container maxWidth="lg" sx={{ paddingRight: 0 }}>
        <Box>
          {!isMobileApp && <MembershipBreadcrumbs additionalBreadcrumbName={'Member details'} />}
          <Typography variant="h3" className="membership-details-title" sx={{ marginTop: '1.5rem ' }}>
            Member details
          </Typography>
          <MembersDetailsActionButtons />
          <MembersDetailsOverview />
        </Box>
      </Container>
    </>
  );
};
